import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  fetchRegions: null,
  setRegionsLoading: ['loading'],
  setCurrentPage: ['currentPage'],
  setRegions: ['regionsList'],
  setPagination: ['pagination'],
  changeItemsToDisplay: ['itemsToDisplay'],
  updateRegionFilterList: ['list'],
  loadRegionRequest: ['regionId'],
  setRegionData: ['data'],
  setRegionDataPropertyHks: ['data', 'newHkIDs', 'propertyID']
});

export const RegionsTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  regionsList: [],
  pagination: {},
  itemsToDisplay: 100,
  currentPage: 1,
  list: {
    state: [],
    city: [],
    officeName: []
  },
  data: {}
};

/* ------- Selectors --------- */
export const RegionsSelectors = {
  selectLoading: state => state.regions.loading,
  selectRegionsList: state => state.regions.regionsList,
  selectPagination: state => state.regions.pagination,
  selectList: state => state.regions.list,
  selectRegionData: state => state.regions.data
};

/* -------- Reducers ---------- */
export const setLoading = (state, { loading }) => ({
  ...state,
  loading
});

export const setRegions = (state, { regionsList }) => {
  return {
    ...state,
    regionsList
  };
};

export const setPagination = (state, { pagination }) => {
  return {
    ...state,
    pagination
  };
};

export const setCurrentPage = (state, { currentPage }) => {
  return {
    ...state,
    currentPage
  };
};

export const changeItemsToDisplay = (state, { itemsToDisplay }) => {
  return {
    ...state,
    currentPage: 1,
    itemsToDisplay
  };
};

export const updateList = (state, { list }) => {
  return {
    ...state,
    list: { ...state.list, ...list }
  };
};

export const setRegionData = (state, { data }) => {
  return {
    ...state,
    data
  };
};

export const setRegionDataPropertyHks = (
  state,
  { data, newHkIDs, propertyID }
) => {
  const newHks = [];
  const weights = [100, 90, 80, 70];
  for (let i = 0; i < newHkIDs.length; i++) {
    let lookUp = data.housekeepers.filter(hk => hk.userID == newHkIDs[i])[0];
    const newHk = {
      weight: weights[i],
      housekeeperID: newHkIDs[i],
      firstName: lookUp.firstName,
      lastName: lookUp.lastName
    };
    newHks.push(newHk);
    data.properties.forEach((p, i) => {
      if (p.propertyID == propertyID) {
        data.properties[i].housekeepers = newHks;
      }
    });
  }
  return {
    ...state,
    data
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_REGIONS_LOADING]: setLoading,
  [Types.SET_REGIONS]: setRegions,
  [Types.SET_PAGINATION]: setPagination,
  [Types.SET_CURRENT_PAGE]: setCurrentPage,
  [Types.CHANGE_ITEMS_TO_DISPLAY]: changeItemsToDisplay,
  [Types.UPDATE_REGION_FILTER_LIST]: updateList,
  [Types.SET_REGION_DATA]: setRegionData,
  [Types.SET_REGION_DATA_PROPERTY_HKS]: setRegionDataPropertyHks
});
